import React, { useEffect, useState } from 'react';
import Button from '../../../shared/components/ui/Button';
import Layout from '../layout/AppLayout';
import Modal from '../../../shared/components/ui/Modal';
import { useLocation, useNavigate, useNavigation, useParams } from 'react-router-dom';
import { ReportAdmin } from './ReportAdmin';
import mixpanel from 'mixpanel-browser';
import Cookies from 'js-cookie';

const SuperAdminAnalytics = () => {
  const [ReportModal, setReportModal] = useState(false);
  const Params = useLocation();
  const navigation = useNavigate();
  const userId = Cookies.get('userId');

  // Track page view
  useEffect(() => {
    mixpanel.track('Super Admin Analytics Page Viewed', {
      user_id: userId,
      timestamp: new Date().toISOString()
    });
  }, [userId]);

  useEffect(() => {
    if (Params.pathname == '/super-admin/analytics') {
      mixpanel.track('Super Admin Analytics Modal Opened', {
        user_id: userId,
        trigger: 'direct_url_navigation',
        timestamp: new Date().toISOString()
      });
      setReportModal(true);
    }
  }, [userId]);

  const handleOnClose = () => {
    mixpanel.track('Super Admin Analytics Modal Closed', {
      user_id: userId,
      timestamp: new Date().toISOString()
    });

    setReportModal(false);
    navigation('/super-admin/home');
  };

  return (
    <>
      <Layout>
        {ReportModal && (
          <Modal
            isDirty={true}
            confirmOnClose={true}
            name={'Reports'}
            width={60}
            onClose={handleOnClose}>
            <ReportAdmin />
          </Modal>
        )}
      </Layout>
    </>
  );
};

export default SuperAdminAnalytics;
